exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2T2gl{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;padding:15px 15px 40px}._2a22w,._2T2gl{position:relative;background:#fff;font-weight:400}._2a22w{font-size:12px;color:#888;padding:15px 20px;margin:15px 0}._2T2gl p,.X3vIP{font-size:15px}.X3vIP{position:relative;line-height:1.96;padding-top:10px}._2T2gl h1,._2T2gl h2,._2T2gl h3,._2T2gl h4{border-radius:2px;border-bottom:5px solid #ffeb3b;font-size:24px;line-height:35px;padding:0 20px 10px;margin:10px 0 20px;text-align:center}._2T2gl img{height:auto;max-width:100%}._2T2gl strong{font-weight:700}", ""]);

// exports
exports.locals = {
	"root": "_2T2gl",
	"title": "_2a22w",
	"contentWrapper": "X3vIP"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/shared/components/About/About.css
// module id = 2536
// module chunks = 15 17